import type {
    DefinedAction,
    GoToAction,
    GoToActionFunction,
    MappedAction,
    MappedActionFunction
} from 'shared/defined-actions/types';
import {isGoToMenuItemAction, isMappedMenuItemAction} from 'shared/defined-actions/utils';

export class DefinedActionPerformer {
    public static readonly serviceName = 'definedActionPerformer';

    private goToActionFunction: GoToActionFunction = () => Promise.resolve();

    private mappedActionFunctions: Map<string, MappedActionFunction> = new Map<string, MappedActionFunction>();

    public async performAction(action: DefinedAction): Promise<any> {
        if (isGoToMenuItemAction(action)) {
            return this.performGoToAction(action);
        }

        if (isMappedMenuItemAction(action)) {
            return this.performMappedAction(action);
        }

        throw new Error(`DefinedAction ${JSON.stringify(action)} is not supported`);
    }

    public registerMappedAction(actionType: string, actionFunction: MappedActionFunction) {
        this.mappedActionFunctions.set(actionType, actionFunction);
    }

    public registerGoToAction(actionFunction: GoToActionFunction) {
        this.goToActionFunction = actionFunction;
    }

    private async performGoToAction(action: GoToAction) {
        return this.goToActionFunction(action.path);
    }

    private async performMappedAction(action: MappedAction) {
        const actionType: string = action.actionType;

        if (!this.mappedActionFunctions.has(actionType)) {
            throw new Error(`Action of type ${actionType} is not registered. Please, register it first in ${DefinedActionPerformer.serviceName}`);
        }

        const actionFunction = this.mappedActionFunctions.get(actionType);
        return actionFunction(action);
    }

}
